import { Event, EventType } from "./Event";

import type { IAddLikeEvent } from "./types";

export class AddLikeEvent extends Event {
  constructor({ itemId, tracking, customEventProperties }: IAddLikeEvent) {
    super({
      event_type: EventType.like,
      event_properties: {
        item_id: itemId,
        tracking,
      },
      custom_event_properties: customEventProperties,
    });
  }
}
